module.exports = __webpack_public_path__ + "media/images/back-red-b48412d7.svg";